export function validateFinalDateInput(input: string | null) {
  if (input === null || input === "") {
    return true
  }

  return !input || /^\d{2}-\d{2}-\d{4}$/.test(input)

  return (
    input.match(
      /^(?:(?:19|20)\d\d)-(0[1-9]|1[0-2]|[1-9])-(0[1-9]|[12]\d|3[01]|[1-9])$/,
    ) !== null
  )
}
